import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PAGE_TITLES = {
  '/': 'Smartorange HUB',
  '/login': 'Вхід',
  '/register': 'Реєстрація',
  '/dashboard': 'Dashboard',
  '/profile': 'Profile',
  '/projects': 'All Projects',
  '/unified-projects': 'All Projects',
  '/pm-projects': 'PM Projects',
  '/tasks': 'Tasks',
  '/review-queue': 'Review Queue',
  '/client-requests': 'Client Requests',
  '/waiting-management': 'Waiting Management',
  '/bank-transactions': 'Bank Transactions',
  '/my-payments': 'My Payments',
  '/my-expenses': 'My Expenses',
  '/pnl-forecast': 'General P&L',
  '/sales-pnl': 'Sales P&L',
  '/crm-pnl': 'CRM P&L',
  '/staff-forecast': 'Staff Forecast',
  '/staff-pnl-detail': 'Staff P&L Detail',
  '/artist-pnl': 'Artist P&L',
  '/payments': 'Artist Payments',
  '/team-expenses': 'Team Salaries',
  '/other-expenses': 'Other Expenses',
  '/sales': 'Sales Projects',
  '/crm-payments': 'CRM Payments',
  '/trp/sales': 'TRP Sales',
  '/users': 'Users',
  '/staff': 'Staff',
  '/clients': 'Clients',
  '/crm-clients': 'CRM Clients',
  '/artists': 'Artists',
  '/candidates': 'Candidates',
  '/service-rates': 'Service Rates',
  '/settings/services': 'Services',
  '/settings/timelines': 'Timelines',
  '/settings/statuses': 'Workflows',
  '/settings/fops': 'FOP Settings',
  '/settings/integrations': 'Integrations',
  '/settings/support-chats': 'Support Chats',
  '/settings/notifications': 'Notifications',
  '/settings/orphaned-projects': 'Orphaned Projects',
  '/artist-dashboard': 'My Dashboard',
  '/artist-tasks': 'My Tasks',
  '/artist-contract': 'Contract',
  '/project-timeline': 'Project Timeline',
};

const SECTION_MAP = {
  '/dashboard': 'Main',
  '/profile': 'Main',
  '/projects': 'Projects',
  '/unified-projects': 'Projects',
  '/pm-projects': 'Projects',
  '/tasks': 'Projects',
  '/review-queue': 'Projects',
  '/client-requests': 'Projects',
  '/waiting-management': 'Projects',
  '/bank-transactions': 'Finance',
  '/my-payments': 'Finance',
  '/my-expenses': 'Finance',
  '/pnl-forecast': 'Finance',
  '/sales-pnl': 'Finance',
  '/crm-pnl': 'Finance',
  '/staff-forecast': 'Finance',
  '/staff-pnl-detail': 'Finance',
  '/artist-pnl': 'Finance',
  '/payments': 'Expenses',
  '/team-expenses': 'Expenses',
  '/other-expenses': 'Expenses',
  '/sales': 'Income',
  '/crm-payments': 'Income',
  '/trp/sales': 'Income',
  '/users': 'Management',
  '/staff': 'Management',
  '/clients': 'Management',
  '/crm-clients': 'Management',
  '/artists': 'Management',
  '/candidates': 'Management',
  '/service-rates': 'Management',
  '/settings': 'Admin',
  '/artist-dashboard': 'Artist',
  '/artist-tasks': 'Artist',
  '/artist-contract': 'Artist',
  '/project-timeline': 'Projects',
};

export const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    
    // Find the matching title
    let title = PAGE_TITLES[path];
    let section = SECTION_MAP[path];
    
    // Handle dynamic routes
    if (!title) {
      if (path.startsWith('/unified-projects/')) {
        title = 'Project Details';
        section = 'Projects';
      } else if (path.startsWith('/tasks/')) {
        title = 'Task Details';
        section = 'Projects';
      } else if (path.startsWith('/candidates/')) {
        title = 'Candidate Details';
        section = 'Management';
      } else if (path.startsWith('/project-timeline/')) {
        title = 'Project Timeline';
        section = 'Projects';
      } else if (path.startsWith('/settings/')) {
        title = path.split('/').pop()?.replace(/-/g, ' ') || 'Settings';
        title = title.charAt(0).toUpperCase() + title.slice(1);
        section = 'Admin';
      } else if (path.startsWith('/trp/')) {
        title = 'TRP';
        section = 'Partner';
      }
    }
    
    // Build the final title
    if (title && title !== 'Smartorange HUB') {
      if (section) {
        document.title = `${title} | ${section} | Smartorange HUB`;
      } else {
        document.title = `${title} | Smartorange HUB`;
      }
    } else {
      document.title = 'Smartorange HUB';
    }
  }, [location.pathname]);
};

export default usePageTitle;
